import { connect } from "react-redux";
import React, { useState, useEffect, useCallback } from "react";
import { withRouter } from "react-router";
import { useTranslation } from "react-i18next";
import DataTable from "react-data-table-component";
import LoadingIcon from "mdi-react/LoadingIcon";
import { configurationsConstants } from "../../../constants";
import { configurationsActions } from "../../../redux/actions";
import GiftCardForm from "../Forms/GiftCardForm";
// eslint-disable-next-line
import { getFilterExpression } from "../../../shared";
import PaginationComponent from "../../../shared/components/PaginationComponent/PaginationComponent";

const { GET_GIFT_CARD_DATA, ACTIVATE_DEACTIVATE_GIFTCARD, ADD_GIFT_CARD } =
  configurationsConstants;

const GiftCardPage = (props) => {
  // eslint-disable-next-line
  const [searchText, setSearchText] = useState("");
  const [pagination, setPagination] = useState({
    pageSize: configurationsActions.DEFAULT_PAGINATION_PAGE_SIZE,
    currentPage: 1,
    totalRows: 0,
  });
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [filterOptionValue, setFilterOptionValue] = useState("");
  const [rowId, setRowId] = useState(0);
  const filterOptions = ["code"];

  const spinner = useCallback(
    (type) => props.spinnerActions.findIndex((f) => f === type),
    [props.spinnerActions]
  );

  const handleCloseForm = () => {
    setIsFormOpen(false);
    props.getGiftCards(
      pagination.pageSize,
      pagination.currentPage,
      getFilterExpression(searchText)
    );
  };
  const { t } = useTranslation("common");
  const columns = [
    {
      name: t("code"),
      selector: "code",
      sortable: true,
      width: "150px",
      cell: (row) => <div className="word-wrap">{row.code}</div>,
    },
    {
      name: t("description"),
      selector: "description",
      sortable: true,
      width: "200px",
      cell: (row) => <div className="word-wrap">{row.description}</div>,
    },
    {
      name: t("value"),
      selector: "value",
      sortable: true,
      width: "150px",
      cell: (row) => {
        return row.value + " $";
      },
    },
    {
      name: t("balance"),
      selector: "balanceAmount",
      sortable: true,
      width: "150px",
      cell: (row) => {
        return row.balanceAmount + " $";
      },
    },
    {
      name: t("start_date"),
      selector: "startDate",
      sortable: true,
      width: "130px",
      cell: (row) => {
        const epoch = row?.startDate * 1000;
        return (
          new Date(epoch).toLocaleDateString() +
          " " +
          new Date(epoch).toLocaleTimeString()
        );
      },
    },
    {
      name: t("end_date"),
      selector: "endDate",
      sortable: true,
      width: "130px",
      cell: (row) => {
        const epoch = row?.endDate * 1000;
        return (
          new Date(epoch).toLocaleDateString() +
          " " +
          new Date(epoch).toLocaleTimeString()
        );
      },
    },

    {
      name: t("actions"),
      width: "170px",
      cell: (row) => (
        <div>
          <button
            type="button"
            className="payment-button mr-2"
            onClick={() => {
              props.giftCardToggleActivation(row.id, row?.isActive);
            }}
          >
            {row?.isActive ? t("Deactivate") : t("Activate")}
          </button>
        </div>
      ),
      allowOverflow: true,
      button: true,
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        fontWeight: "bold",
      },
    },
  };

  useEffect(() => {
    props.getGiftCards(
      pagination.pageSize,
      pagination.pageNumber,
      getFilterExpression(searchText)
    );
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setPagination({
      pageSize: props.giftCards?.pageSize,
      pageNumber: props.giftCards?.currentPage,
      totalRows: props.giftCards?.total,
    });
  }, [props.giftCards]);

  return (
    <div className="row mr-0">
      <div className="col-md-12">
        <div className="col-md-12 mx-0">
          <div className="tab-content">
            {spinner(GET_GIFT_CARD_DATA) &&
            spinner(ADD_GIFT_CARD) &&
            spinner(ACTIVATE_DEACTIVATE_GIFTCARD) ? (
              <div className="tab-pane fade show active">
                {isFormOpen ? (
                  <GiftCardForm rowId={rowId} onClose={handleCloseForm} />
                ) : (
                  <>
                    <button
                      type="submit"
                      className="btn btn-info ml-2 mb-0"
                      onClick={() => {
                        setRowId(0);
                        setIsFormOpen(true);
                      }}
                    >
                      Add Gift Card
                    </button>
                    <div className="pagination-controls">
                      <PaginationComponent
                        pagination={pagination}
                        setPagination={setPagination}
                        searchText={searchText}
                        setSearchText={setSearchText}
                        getTableData={props.getGiftCards}
                        filterOptionValue={filterOptionValue}
                        setFilterOptionValue={setFilterOptionValue}
                        filterOptions={filterOptions}
                        isTable
                      />
                    </div>
                    <DataTable
                      columns={columns}
                      data={props.giftCards.items}
                      highlightOnHover
                      responsive
                      customStyles={customStyles}
                      className="sticky-header-class"
                    />
                  </>
                )}
              </div>
            ) : (
              <div className="text-center mt-4">
                <LoadingIcon className="loading-spinner" />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  giftCards: state.configurations.giftCards,
  spinnerActions: state.system.spinnerActions,
});

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  getGiftCards: (pageSize, pageIndex, filterExpression) =>
    dispatch(
      configurationsActions.getGiftCards(pageSize, pageIndex, filterExpression)
    ),
  giftCardToggleActivation: (id) =>
    dispatch(configurationsActions.giftCardToggleActivation(id)),
});

// Mapping action and store the function via props
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(GiftCardPage));
